<template>
  <div class="sub-section">
    <ViewModeSubsection />
  </div>
</template>

<script>
import ViewModeSubsection from '~/components/Lobby/ViewModeSubsection'
import { mapActions } from 'vuex'

export default {
  name: 'SubSectionPage',
  components: {
    ViewModeSubsection,
  },
  async asyncData({ store }) {
    await Promise.allSettled([
      store.dispatch('lobby/reset_subsectionItem'),
      store.dispatch('lobby/reset_providerItem'),
      store.dispatch('lobby/reset_collectionItem'),
    ])
  },
  async fetch() {
    return await this.fetch_seoPage(this.$route.path)
  },
  methods: {
    ...mapActions('seo', ['fetch_seoPage']),
  },
}
</script>
